import Image from 'next/image';
import { emblemSrc } from '@/lib/streaks';
import { cn } from '@/lib/ui/utils';

interface TierEmblemProps {
  /** 0 = no streak (grey emblem), 1..7 = Spark..Eternal. */
  level: number;
  /** Rendered pixel size (square). */
  size: number;
  alt?: string;
  className?: string;
}

/** The flame emblem for a streak level. */
export function TierEmblem({
  level,
  size,
  alt = '',
  className,
}: TierEmblemProps): React.JSX.Element {
  return (
    <Image
      src={emblemSrc(level)}
      alt={alt}
      width={size}
      height={size}
      className={cn('object-contain', className)}
    />
  );
}
